import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../services/apiClient';
import { useUser } from '../auth/useUser';
import type { SupportMeetingStatus } from './types';

/**
 * サポートミーティングの状況（無料枠・予約 URL・実施履歴）を取得するフック。
 *
 * MenuContent は PC/モバイルで同時マウントされるため、複数箇所から呼んでも
 * React Query の queryKey で dedupe され 1 回の fetch に集約される。
 * 組織切替時にキャッシュが混ざらないよう organization_id を queryKey に含める。
 *
 * @param enabled ログイン時のみ true を渡す（未ログイン時は fetch しない）
 */
export function useSupportMeeting(enabled: boolean) {
  const { user } = useUser();
  const orgId = user?.organization_id ?? null;

  return useQuery<SupportMeetingStatus>({
    queryKey: ['support-meeting', orgId],
    queryFn: async () => {
      const response = await apiClient.get('/support-meeting/status');
      return response.data;
    },
    enabled: enabled && !!user,
    staleTime: 5 * 60 * 1000, // 5分キャッシュ
  });
}
